import { ref, watch, onBeforeUnmount } from 'vue'
import { getImageDownloadUrl } from '@/api/image-download-url'
import config from '@/config'
import { unsavedImages } from '@/modules/shared/CommentEditor/plugins/useUnsavedImages'

export const redirectedImagesStore = {}

const notUploaded = (newSrc: string) => {
  const imageWithSrcUrl = Object.values(unsavedImages).find((img) => img.signedUrlResponse?.url === newSrc)
  return imageWithSrcUrl && !imageWithSrcUrl.uploaded
}

export const useRedirectedImageSource = (watchFn: () => any) => {
  const src = ref('')
  let currentFileName = ''

  watch(
    () => [watchFn(), notUploaded(watchFn())],
    async ([newSrc, notUploadedYet]) => {
      if (!newSrc?.includes(`uploads.${config.domainRoot}`)) {
        src.value = newSrc || ''
        currentFileName = ''
        return
      }

      if (notUploadedYet) return

      const fileName = newSrc.split('/').pop()
      currentFileName = fileName

      if (!redirectedImagesStore[fileName]) {
        try {
          const { downloadUrl } = await getImageDownloadUrl(fileName)
          const response = await fetch(downloadUrl)

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`)
          }

          redirectedImagesStore[fileName] = URL.createObjectURL(await response.blob())
        } catch (error) {
          // Remove from cache if download fails
          console.error(`Failed to load image: ${fileName}`, error)
          delete redirectedImagesStore[fileName]
          src.value = ''
          return
        }
      }

      src.value = redirectedImagesStore[fileName]
    },
    { immediate: true },
  )

  onBeforeUnmount(() => {
    // Clean up the specific image blob URL
    if (currentFileName && redirectedImagesStore[currentFileName]) {
      URL.revokeObjectURL(redirectedImagesStore[currentFileName])
      delete redirectedImagesStore[currentFileName]
    }
    src.value = ''
  })

  return { src }
}
